import { WeatherIcons } from '$tablet-app/assets/weatherIcons';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { weather_functions } from '@akin-home/weather';
import { getWeatherQuery } from '@akin-home/weather-frontend';
import { LinearGradient } from 'expo-linear-gradient';
import * as Location from 'expo-location';
import { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { useQuery } from 'react-query';
import styled from 'styled-components/native';
import FullScreenLoader from '../../components/FullScreenLoader';
import DashboardPanel from '../DashboardPanel';
import { WeatherHourItem } from './WeatherHourItem';

export const WeatherDashboardWidget = () => {
  const [location, setLocation] = useState<
    { latitude: number; longitude: number } | undefined
  >();

  const { data, isLoading } = useQuery(
    ['weather', location],
    () =>
      location &&
      getWeatherQuery({
        latitude: location.latitude,
        longitude: location.longitude,
      }),
    { enabled: !!location }
  );

  const [status, requestPermission] = Location.useForegroundPermissions({
    request: false,
  });

  const updateLocation = async () => {
    const location = await Location.getCurrentPositionAsync({});

    const { latitude, longitude } = location.coords;

    setLocation({
      latitude,
      longitude,
    });
  };

  useEffect(() => {
    if (status?.granted) {
      updateLocation();
    }
  }, [status]);

  return (
    <Panel>
      <GradientBackground colors={gradient_colors} />
      {status && !status?.granted && status?.canAskAgain ? (
        <PlaceholderContainer>
          <Button onPress={requestPermission}>
            Enable location permission to see current weather
          </Button>
        </PlaceholderContainer>
      ) : isLoading || !data ? (
        <FullScreenLoader />
      ) : (
        <>
          <TopSection>
            <LeftSide>
              <Icon source={WeatherIcons[weather_functions.getIcon(data)]} />
              <TextContainer>
                <Text color="white">
                  {weather_functions.getWeatherDescription(data)}
                </Text>
              </TextContainer>
            </LeftSide>

            <TemperatureText weight="bold" color="white">
              {weather_functions.getTemperatureText(data)}
            </TemperatureText>
          </TopSection>

          {data.hourly ? (
            <List
              data={data.hourly}
              contentContainerStyle={styles.hours_list}
              horizontal
              renderItem={({ item }) => (
                <WeatherHourItem
                  time={weather_functions.getHourTimeText(data, item)}
                  icon={weather_functions.getHourIcon(item)}
                  temperature={weather_functions.getHourTemperatureText(item)}
                />
              )}
            />
          ) : null}
        </>
      )}
    </Panel>
  );
};

const Panel = styled(DashboardPanel)`
  padding: 20px;
  flex: 1;
  overflow: hidden;
`;

const PlaceholderContainer = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const TopSection = styled.View`
  flex-direction: row;
  gap: 16px;
  flex: 1;
`;

const LeftSide = styled.View`
  flex: 1;
  gap: 16px;
`;

const TextContainer = styled.View`
  gap: 6px;
`;

const TemperatureText = styled(Text)`
  font-size: 72px;
`;

const Icon = styled.Image`
  height: 72px;
  width: 72px;
`;

const List = styled.FlatList`
  flex-grow: 0;
`;

const GradientBackground = styled(LinearGradient)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

const gradient_colors = ['#646CFF', '#ACBBFF'];

const styles = StyleSheet.create({
  hours_list: {
    gap: 20,
  },
});
